import { BonusControllerApi } from '@/http/apis/BonusControllerApi'

const bonusApi = new BonusControllerApi()

export interface BonusHistoryQuery {
  userCode: string
  currentPage?: number
  pageSize?: number
  startDate?: string
  endDate?: string
  type?: number
}

export const bonusService = {
  async getAccount() {
    const response = await bonusApi.bonusAccountGet()
    return response?.data || null
  },

  async getHistory(params: BonusHistoryQuery) {
    return await bonusApi.bonusAdminHistoryPageGet(params)
  },
}
